import { render, staticRenderFns } from "./DataSettings.vue?vue&type=template&id=54ceee11&scoped=true&"
import script from "./DataSettings.vue?vue&type=script&lang=ts&"
export * from "./DataSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ceee11",
  null
  
)

export default component.exports